import { useRef, useEffect } from "react";

// Este hook se acciona cuando el usuario hace clic fuera de un elemento en particular y los elementos establecidos como excepciones a esta condición.

// PARAMETROS:
// Callback: función que se ejecuta cuando se cumple la condición (clic fuera)
// Exceptions: arreglo de refs a elementos del dom que no deben ser considerados en la condición. El outside click se aplicaría cuando no se presione el elemento principal y estos elementos.

// RETORNA un ref que se puede asignar a un elemento del dom a crearse en el function component.
const useOutsideClick = (callback, exceptions = []) => {
  const ref = useRef();

  useEffect(() => {
    const handleClick = (event) => {
      for (const exception of exceptions) {
        if (!exception.current) {
          return;
        }
        if (exception.current.contains(event.target)) {
          return;
        }
      }
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref]);

  return ref;
};

export default useOutsideClick;
